import { render, staticRenderFns } from "./ModelLayoutExpansion.vue?vue&type=template&id=30d7112d"
import script from "./ModelLayoutExpansion.vue?vue&type=script&lang=js"
export * from "./ModelLayoutExpansion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports